import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getLicenseAlertClass, getLicenseAlertText, isLicenseExpired } from "../../services/license";
import { OrganizationState } from "../../services/organizations/types";

interface Props {
	organization: OrganizationState;
	topStyle?: string;
}

const LicenseExpiringNotification = (props: Props) => {
	const { t } = useTranslation();
	const organization = props.organization;
	const licenseType = organization.license_type;
	const licenseExpiredAt = organization.license_expires_at ?? "";

	if (!isLicenseExpired(organization.license_expires_at, organization.license_type, organization.timezone)) {
		return null;
	}

	return (
		<Link
			to={`/${organization.id}/subscriptions`}
			className={`license-${getLicenseAlertClass(licenseExpiredAt, licenseType, organization.timezone)}`}
			style={{ top: props.topStyle ? props.topStyle : 0 }}
		>
			{getLicenseAlertText(t, licenseExpiredAt, licenseType, organization.timezone)}
		</Link>
	);
};
export default LicenseExpiringNotification;
